module.exports = __webpack_public_path__ + "static/media/portfolio-img1.348e58ea.jpg";